import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GroupEditModal from './GroupEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.groupEditModal.status,
  id: state.modal.groupEditModal.id,
  name: state.modal.groupEditModal.name
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_GROUP_EDIT, { status: false, id: null, name: null }),
  editGroup: actions.group.editGroup,
  getUsers: actions.user.getUsers
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/GroupEditModal/index.js